import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getItem, setItem, tokenPaths } from '../../utils/localStorage'
import { ThemeKey } from '../../actions/themes'

export interface ThemeState {
  currentTheme: ThemeKey
}

const validThemes: ThemeKey[] = ['main', 'dcu', 'nafBrand']

const initialState = (): ThemeState => {
  let stored = getItem(tokenPaths.theme) as ThemeKey | undefined
  if (!stored || !validThemes.includes(stored)) stored = 'main'
  return { currentTheme: stored }
}

const themeSlice = createSlice({
  name: 'theme',
  initialState: initialState(),
  reducers: {
    storeTheme(state, action: PayloadAction<ThemeKey>) {
      setItem(tokenPaths.theme, action.payload)
      state.currentTheme = action.payload
    },
  },
})

export const { storeTheme } = themeSlice.actions
export default themeSlice.reducer
